// extracted by mini-css-extract-plugin
export var info = "InfoPanel-module--info--017ab";
export var infoProfile = "InfoPanel-module--infoProfile--a0adb";